
import React, { useContext, useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import styled from "styled-components";
import { AppContext } from "../../../contexts/AppContext";


const EditWorkflowSidebarWrapper = styled.div`
  width: 250px;
  background-color: var(--sidebar-bg);
  border: 1px solid var(--sidebar-border-color);
  box-sizing: content-box;
  margin-left: -20px;
  margin-top: -40px;
  z-index: 1;

  height: auto;
  position:sticky;
`;

const EditWorkflowSidebarInnerWrapper = styled.div`
  width: 250px;
  overflow: hidden auto;
  height: 100vh;
  padding: 20px 16px 8px 16px;
  display: flex;
  flex-direction: column;
  position: fixed;
`;

const EditWorkflowSidebarItems = styled.div`
  margin-top: 20px;
`;

const EditWorkflowSidebarItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 18px;
  padding: 13px 5px 13px 10px;
  border-radius: 8px;
  cursor: pointer;

  &.active {
    background-color: var(--sidebar-active-item-bg);
  }

  &.active  * {
    color: var(--sidebar-active-item-color) !important;
  }

  &:hover:not(.active) {
    background-color: var(--sidebar-active-item-bg);
  }
`;

const EditWorkflowSidebarItemText = styled.span`
  font-size: 16px;
  font-weight: 300;
  color: var(--sidebar-item-color);
  padding-left: 10px;
`;

const EditWorkflowSidebarItemIcon = styled(Icon)`
  font-size: 18px;
  color: var(--sidebar-item-color);
`;

export const EditWorkflowSidebar = ({
  show = true,
  defaultSelectedTab = window.location.hash ? window.location.hash.substr(1) : "details",
  onNavItemClicked = () => { },
  onToggle = () => { },
}) => {
  console.log("!!! DEFAULT SELECTED TAB: ", defaultSelectedTab)
  const [selectedTab, setSelectedTab] = useState(defaultSelectedTab);

  const { selectedClient } = useContext(
    AppContext
  );
  console.log("!!! SIDEBAR SELECTED CLIENT: ", selectedClient)

  useEffect(() => {
    setSelectedTab(defaultSelectedTab);
  }, [defaultSelectedTab]);

  useEffect(() => {
    window.history.pushState(null, null, `#${selectedTab}`);
    onNavItemClicked(selectedTab);

    // eslint-disable-next-line
  }, [selectedTab]);

  const selectTab = (tab) => {
    setSelectedTab(tab);
    // Update to use the has of the tab
  };

  const isSelected = (tab) => {
    console.log("!!! CHECKING IF SELECTED: ", tab, selectedTab, selectedTab === tab);
    return selectedTab === tab ? "active" : "";
  }


  return (
    <EditWorkflowSidebarWrapper
      style={{
        width: show ? "250px" : "24px",
        transition: "width 0.3s ease-in-out",
        height: "100vh",
        marginTop: "-20px",
      }}
    >
      <button
        onClick={() => {
          onToggle();
        }}
        style={{
          width: "24px",
          height: "40px",
          backgroundColor: "var(--sidebar-active-item-bg)",
          color: "var(--sidebar-active-item-color)",
          borderTopRightRadius: ".25rem",
          borderBottomRightRadius: ".25rem",
          outline: "none",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "absolute",
          top: "50%",
          right: "-24px",
          zIndex: 1,
          border: "none",
          cursor: "pointer",
          fontSize: "20px",
        }}
      >
        <i className="fas fa-ellipsis-v"></i>
      </button>
      <EditWorkflowSidebarInnerWrapper

        style={{ display: show ? "flex" : "none" }}
      >
        <EditWorkflowSidebarItems style={{ flexGrow: 0 }}>
          <EditWorkflowSidebarItem className={isSelected("details")} onClick={() => selectTab("details")}>
            <span>
              <EditWorkflowSidebarItemIcon icon="lucide:info" />
            </span>
            <EditWorkflowSidebarItemText>Details</EditWorkflowSidebarItemText>
          </EditWorkflowSidebarItem>
          <EditWorkflowSidebarItem className={isSelected("workflow-graph")} onClick={() => selectTab("workflow-graph")}>
            <span>
              <EditWorkflowSidebarItemIcon icon="lucide:bot" />
            </span>
            <EditWorkflowSidebarItemText>Workflow Graph</EditWorkflowSidebarItemText>
          </EditWorkflowSidebarItem>
          <EditWorkflowSidebarItem
            className={isSelected("dynamic-workflow")}
            onClick={() => selectTab("dynamic-workflow")}
            title="Edit this workflow's graph with the new dynamic nodes"
          >
            <span>
              <EditWorkflowSidebarItemIcon icon="lucide:square-arrow-out-up-right" />
            </span>
            <EditWorkflowSidebarItemText>Dynamic Graph</EditWorkflowSidebarItemText>
          </EditWorkflowSidebarItem>
          <EditWorkflowSidebarItem
            className={isSelected("triggers")}
            onClick={() => selectTab("triggers")}
            title="Schedules, API endpoints, webhooks and sub-workflow callers"
          >
            <span>
              <EditWorkflowSidebarItemIcon icon="lucide:bolt" />
            </span>
            <EditWorkflowSidebarItemText>Instantiation</EditWorkflowSidebarItemText>
          </EditWorkflowSidebarItem>
        </EditWorkflowSidebarItems>
      </EditWorkflowSidebarInnerWrapper>
    </EditWorkflowSidebarWrapper>
  );
};

export default EditWorkflowSidebar;
